import React from 'react';
import { browserHistory } from 'react-router-dom'

import Overlay from 'Core/Components/Overlay';
import LinkBox from 'Core/Components/LinkBox';

class PhotoCard extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { card } = this.props;
    const { image, title, subtitle, caption, url } = card;
    return (
      <LinkBox to={url} className="PhotoCard xs-12 md-6">
        <Overlay
          className="PhotoCard-Content"
          image={image.url}
          position={image.position}
          innerClass="PhotoCard-Inner"
        >
          <h6>{subtitle}</h6>
          <h3>{title}</h3>
          <hr />
          <p dangerouslySetInnerHTML={{ __html: caption }} />
        </Overlay>
      </LinkBox>
    )
  }
}

export default PhotoCard;



// WEBPACK FOOTER //
// ./client/Core/Components/PhotoCard.jsx